import React from "react";
import styled from "styled-components";
import { v4 as uuidv4 } from "uuid";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";

//
import PageTop from "../../sections/PageTop";
import SingleServiceTop from "./sections/SingleServiceTop";
import SingleServiceCEO from "./sections/SingleServiceCEO";
import SERVICELIST from "../../assets/data/service-list";
import BookAppointment from "../../sections/BookAppointment";
import SingleServiceWhy from "./sections/SingleServiceWhy";
import AboutClinicForm from "../aboutClinic/sections/AboutClinicForm";
import Location from "../../sections/Location";

const linkChain = [
  {
    id: uuidv4(),
    title: "navHome",
    to: "/",
  },
  {
    id: uuidv4(),
    title: "footerServiceAll",
    to: "/service/all",
  },
  {
    id: uuidv4(),
    title: "",
  },
];

export default function SingleService() {
  const { t } = useTranslation();
  const params = useParams();
  const SERVICE = SERVICELIST[Number(params.id) - 1];

  linkChain[2] = { ...linkChain[2], title: SERVICE.title };

  return (
    <StyledSingleService>
      <PageTop title={t(linkChain[2].title)} linkList={linkChain} />
      <SingleServiceTop service={SERVICE} />
      <SingleServiceCEO />
      <BookAppointment />
      <SingleServiceWhy />
      <AboutClinicForm />
      <Location />
    </StyledSingleService>
  );
}

const StyledSingleService = styled.main``;
